<template>
  <span>
    <crud-layout-search
      ref="crudLayoutSearch"
      :params="params"
      :interface="nmInterface"
      :id="id"
      :row-buttons="true"
      multiselect
      :name="name"
    >
    </crud-layout-search>
  </span>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'

const { page, pageTable, CrudLayoutSearch } = JtCrud
@Component({
  mixins: [page],
  name: 'Danfe',
  components: {
    CrudLayoutSearch,
    page,
    pageTable
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Danfe extends Vue {
  get nmInterface () {
    return this.interface
  }

  get page () {
    return page
  }

  mounted () {
    this.$refs.crudLayoutSearch.onButton('btReintegrateDanfe', this.integrateDanfe)
  }

  async integrateDanfe ({ params }) {
    await repository.resolveLogic('latisDanfe.reintegrateDanfe', params)
    this.$refs.crudLayoutSearch.refresh()
  }
}
export default Danfe
</script>
<style lang="stylus" scoped></style>
